// Change Handlers
function _notifyChangeHandlers(handlers, modifiedItem){
  handlers.forEach((handler, i) => {
    handler(modifiedItem);
  });
}

export default class CommonDataManager {

    static myInstance = null;

    //States
    _landing_loaded = false;
    _loaded_locale = null;

    //Change handlers
    _landingLoadedHandlers = [];
    _loadedLocaleHandlers = [];

    /**
     * @returns {CommonDataManager}
     */
    static getInstance() {
        if (CommonDataManager.myInstance == null) {
            CommonDataManager.myInstance = new CommonDataManager();
        }
        return this.myInstance;
    }

    //GET
    getLandingLoaded() {
        return this._landing_loaded;
    }
    getLoadedLocale() {
        return this._loaded_locale;
    }

    //SET
    setLandingLoaded(loaded) {
      this._landing_loaded = loaded;
      _notifyChangeHandlers(this._landingLoadedHandlers, loaded);
    }
    setLoadedLocale(locale) {
      this._loaded_locale = locale;
      _notifyChangeHandlers(this._loadedLocaleHandlers, locale);
    }

    //CALLBACKS
    setLandingLoadedHandler(callback){
      if (!this._landingLoadedHandlers.includes(callback)) {
        this._landingLoadedHandlers.push(callback);
      }
    }
    setLoadedLocaleHandler(callback){
      if (!this._loadedLocaleHandlers.includes(callback)) {
        this._loadedLocaleHandlers.push(callback);
      }
    }

}
